import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_84s66t3hhw: FaireBrandEntity = {
  token: "b_84s66t3hhw",
  type: "brand",
  name: "Suzy Spa Essentials",
  avatarUrl:
    "https://cdn.faire.com/fastly/907fc272b8c2185340dd8b7a34ce45caad595973add8eb6bea1e49d27269cb54.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/7a6344c581777fcf4bed4a6d1fb8b98b58dbaae2d4e1fdc5192be445a615a9e1.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/907fc272b8c2185340dd8b7a34ce45caad595973add8eb6bea1e49d27269cb54.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/7a6344c581777fcf4bed4a6d1fb8b98b58dbaae2d4e1fdc5192be445a615a9e1.jpeg",
  location: "Miami, FL, USA",
  minimumOrderDollars: 15,
  rating: 5,
  reviewCount: 1,
  isInsider: true,
  description:
    "I have been in the aesthetics industry for over 35 years, making people feel beautiful.  This has always been my passion.  My customers are my number one priority in my thriving hair and nail salon business.  I branched out in 2014 because my oldest son was getting married and I wanted to help him and his bride fulfill their dreams.\n \nAt that time, I started making my body scrubs to raise money and my customers loved them. Additionally, for the wedding, I made personalized hand-poured soy candles for decorations, which led people to reach out and start ordering both the candles and the scrubs and that was the beginning of Suzy’s Spa Essentials.\n\nFrom the very beginning of this new venture, I started looking for increasingly more natural and safer products for my clients to use, but was not satisfied with what I found.  I then started introducing all-natural products such as soaps, linen sprays, body butter, hair masks, spray leave-in conditioners, and continued on to creating foaming hand soaps and the list goes on.\n \nAll my products are handmade by me with tender love and care in my home kitchen.",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:51:08.668Z",
    importedBy: "entity-db-cli",
  },
};
